export default "__VITE_ASSET__CEeYbnzQ__"